module.exports = __webpack_public_path__ + "img/forbidden.27976a94.svg";